<template>
    <div class="graphical-email-template-select-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Choose Template</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <template-display
                    multiselector
                    primary
                    :initialSelectedItems="initialSelectedItems"
                    :hasCardOptions="false"
                    @select="select" />
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-btn" @click="closeWidget">
                        Cancel
                    </app-button>
                </div>
                <div class="action-container">
                    <app-button @click="confirmTemplates()">Choose these templates</app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');
const TemplateDisplay = () => import('@/components/campaign/template-display');
import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'graphical-email-template-select-widget',

    props: {
        widget: {
            type: Object,
            required: true
        }
    },

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'template-display': TemplateDisplay,
    },

    data() {
        return {
            allowMultipleSelections: this.widget.allowMultipleSelections || false,
            selectedItems: [],
            initialSelectedItems: []
        };
    },

    computed: {
        graphicalTemplatesIds(){
            return this.selectedItems.map(template => template.id);
        }
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        select(items) {
            this.selectedItems = items;
        },

        confirmTemplates() {
            EventBus.$emit('template:select', this.graphicalTemplatesIds);
            this.closeWidget();
        }
    },

    created() {
        if (this.widget.initialSelectedIds) {
            this.initialSelectedItems = this.widget.initialSelectedIds.map(templateId => { 
                return { id: templateId };
            });
        }
    }
}
</script>

<style>
.graphical-email-template-select-widget .content-wrapper {
    padding: 0 35px;
}

.graphical-email-template-select-widget .master-display .master-cards .master-card-wrapper {
    padding: 0;
}

.graphical-email-template-select-widget .master-display .display-title {
    display: none;
}

.graphical-email-template-select-widget .app-multiselect-new.multiselect .multiselect__tags {
    background: transparent;
    padding-left: 6px;
}

.graphical-email-template-select-widget .cancel-btn {
    background: transparent;
    color: #877D88;
    border: none;
}

.graphical-email-template-select-widget .cancel-btn:hover {
    background: #E1E0E5;
}

.graphical-email-template-select-widget .template-display .master-card .title-row {
    padding-top: 10px;
}

.graphical-email-template-select-widget .master-card {
    margin: 0 5px;
}

.graphical-email-template-select-widget .template-display .template-title {
    max-width: 240px;
}

.graphical-email-template-select-widget .widget-contents-container .content-wrapper {
    padding-top: 0;
}
</style>